import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Fade,
  Typography,
  Box,
  Backdrop,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SelectField from "../formElements/SelectField";
import { API, graphqlOperation } from "aws-amplify";
import { getPartyAddressEntity, getCodeTranslation,getPartyMaster } from "../../graphql/queries";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: "none",
};
const Countries = [{ option: "India", value: "IndiaState" }]
const EditCreditDeliveryAddress = ({ open, setOpen, partyID, setDeliveryAddressDetails, CrDrId, setStateArr,
  setDistrictArr,
  setCountryArr, data, gstStatus,setData }) => {
  const [state, setState] = useState({
    deliveryAddress: "",
    states: "",
    district: "",
    country: "",
    pincode: "",
    consigneeName: "",
    gstin: "",

    errorStatus: {
      deliveryAddress: false,
      states: false,
      district: false,
      country: false,
      pincode: false,
      consigneeName: false,
      gstin: false,
    },
    errorFields: {
      deliveryAddress: "",
      states: "",
      district: "",
      country: "",
      pincode: "",
      consigneeName: "",
      gstin: "",
    },
  });
  const [backdropOpen, setBackdropOpen] = useState(false)
  const [countries, SetCountries] = useState("");
  const [countrtyStates, setCountryStates] = useState("");
  const [District, setDistrict] = useState("");
  const [saveAddressDetailsBackUp, setSaveAddressDetailsBackUp] = useState([])
  const [partyDetails,setPartyDetails]=useState([]) 
  const handleClose = (event, reason) => {
    if (reason !== "backdropClick") {
      setOpen(false);
      setState((prev) => ({
        ...prev,
        deliveryAddress: "",
        states: "",
        district: "",
        country: "",
        pincode: "",


        errorStatus: {
          deliveryAddress: false,
          states: false,
          district: false,
          country: false,
          pincode: false,

        },
        errorFields: {
          deliveryAddress: "",
          states: "",
          district: "",
          country: "",
          pincode: "",
        },
      }))
    }


  };
  function formValidation(data) {
    let isvalid = true;
    let obj = { ...state };

    Object.keys(data).map((key) => {
      if (key === "billingAddress") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.billingAddress = "Delivery Address is required";
          obj.errorStatus.billingAddress = true;
        } else {
          // isvalid=true;
          obj.errorFields.billingAddress = "";
          obj.errorStatus.billingAddress = false;
        }
      }
      if (key === "pincode") {

        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.pincode = "Postal / Zip Code required";
          obj.errorStatus.pincode = true;
        } else if ((!new RegExp(/^\d{6}$/).test(data[key]))) {
          isvalid = false;
          obj.errorFields.pincode = "Invalid Postal / Zip Code ";
          obj.errorStatus.pincode = true;
        } else {
          obj.errorFields.pincode = "";
          obj.errorStatus.pincode = false;
        }

      }

      if (key === "country") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.country = "Country is required";
          obj.errorStatus.country = true;
        } else {
          // isvalid=true;
          obj.errorFields.country = "";
          obj.errorStatus.country = false;
        }
      }

      if (key === "states") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.states = "State/Province is required";
          obj.errorStatus.states = true;
        } else {
          // isvalid=true;
          obj.errorFields.states = "";
          obj.errorStatus.states = false;
        }
      }
      if (key === "district") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.district = "District is required";
          obj.errorStatus.district = true;
        } else {
          // isvalid=true;
          obj.errorFields.district = "";
          obj.errorStatus.district = false;
        }
      }
      if (key === "consigneeName") {
        if (data[key].trim().length <= 0) {
          isvalid = false;
          obj.errorFields.consigneeName = "Consignee Name is required";
          obj.errorStatus.consigneeName = true;
        } else {
          obj.errorFields.consigneeName = "";
          obj.errorStatus.consigneeName = false;
        }
      }
      if(partyDetails.GSTCategory!=="UB"){
      if (gstStatus !== 1) {
        if (key === "gstin") {
          // if (data[key].trim().length <= 0) {
          //   isvalid = false;
          //   obj.errorFields.gstin = "GSTIN is required";
          //   obj.errorStatus.gstin = true;
          // } else
           if (
            !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Za-z]{1}$/.test(
              data[key]
            )
          ) {
            isvalid = false;
            obj.errorFields.gstin = "Enter Valid GSTIN";
            obj.errorStatus.gstin = true;
          } else {
            obj.errorFields.gstin = "";
            obj.errorStatus.gstin = false;
          }
        }
      }
    }
    });
    setState(obj);
    return isvalid;
  }
  async function getCountries() {
    setBackdropOpen(true);
    let code = "Country";
    const cities = await API.graphql(
      graphqlOperation(getCodeTranslation, { CodeType: code })
    );
    if (cities?.data?.getCodeTranslation != null) {
      let countriesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}State`,
        };
      });
      SetCountries(countriesArray);
    }
    setBackdropOpen(false);
  }
  async function getStates(code) {
    setBackdropOpen(true);
    const cities = await API.graphql(
      graphqlOperation(getCodeTranslation, { CodeType: code })
    );
    if (cities?.data?.getCodeTranslation != null) {
      let statesArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}District`,
        };
      });
      setCountryStates(statesArray);
      setStateArr(statesArray)
    }
    setBackdropOpen(false);
  }
  async function getDistricts(state) {


    try {

      const cities = await API.graphql(
        graphqlOperation(getCodeTranslation, { CodeType: state })
      );

      let disArray = (cities?.data?.getCodeTranslation).map((element) => {
        return {
          option: element.CodeText,
          value: `${element.CodeText}District`,
        };
      });
      setDistrict(disArray)
      setDistrictArr(disArray)
    } catch (error) {
    }
  }
  async function getAddressDetails() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          ObjectID: partyID,
          ObjectType: "PartyDelivery",
        })
      );
      if (saveAddressDetailsBackUp.length !== 0) {
        saveAddressDetailsBackUp.map((data) => {
          setState((prev) => ({
            ...prev,
            deliveryAddress: data?.deliveryAddress.replace('**', '\n'),
            country: data?.country,
            states: data?.states,
            district: data?.district,
            pincode: data?.pincode
          }))
        })
      } else {
        if (resPartyAddressEntityDetails?.data.getPartyAddressEntity != null) {
          setState((prev) => ({
            ...prev,
            deliveryAddress: resPartyAddressEntityDetails?.data.getPartyAddressEntity.Line1.replace('**', '\n'),
            country: resPartyAddressEntityDetails?.data.getPartyAddressEntity.CountryCode,
            states: resPartyAddressEntityDetails?.data.getPartyAddressEntity.StateCode,
            district: resPartyAddressEntityDetails?.data.getPartyAddressEntity.City,
            pincode: resPartyAddressEntityDetails?.data.getPartyAddressEntity.PINCode
          }))
        }
      }
    }
    catch (error) {
      console.log("error", error);
    }
  }
  async function getAddressDetailsByCrDrId() {
    try {
      const resPartyAddressEntityDetails = await API.graphql(
        graphqlOperation(getPartyAddressEntity, {
          ObjectID: CrDrId,
          ObjectType: "CreditDelivery",
        })
      );
      if (saveAddressDetailsBackUp.length !== 0) {
        saveAddressDetailsBackUp.map((data) => {
          setState((prev) => ({
            ...prev,
            deliveryAddress: data?.deliveryAddress.replace('**', '\n'),
            country: data?.country,
            states: data?.states,
            district: data?.district,
            pincode: data?.pincode
          }))
        })
      } else {
        if (resPartyAddressEntityDetails?.data.getPartyAddressEntity != null) {
          setState((prev) => ({
            ...prev,
            deliveryAddress: resPartyAddressEntityDetails?.data.getPartyAddressEntity.Line1.replace('**', '\n'),
            country: resPartyAddressEntityDetails?.data.getPartyAddressEntity.CountryCode,
            states: resPartyAddressEntityDetails?.data.getPartyAddressEntity.StateCode,
            district: resPartyAddressEntityDetails?.data.getPartyAddressEntity.City,
            pincode: resPartyAddressEntityDetails?.data.getPartyAddressEntity.PINCode,
          }))
        }
      }
    }
    catch (error) {
      console.log("error", error);
    }
  }
  async function getPartyDetails(){
    try{
      const resParty = await API.graphql(
        graphqlOperation(getPartyMaster, { PartyID:  partyID })

      );
      setPartyDetails(resParty.data.getPartyMaster)
    }catch(error){
      console.log("error");
    }
  }
  useEffect(() => {
    setCountryArr(Countries)
  }, [])
  useEffect(() => {
    if (CrDrId == "") {
      getAddressDetails()
      getPartyDetails()
    } else {
      getAddressDetailsByCrDrId()
    }
    getCountries()
    getStates("IndiaState")
    getDistricts("KeralaDistrict")
  }, [open])
  async function saveChanges() {
    const {
      deliveryAddress,
      country, states, district, pincode, gstin, consigneeName
    } = state
    const formData = {
      deliveryAddress,
      country, states, district, pincode, gstin, consigneeName
    }
    let nameOfstate = ""
    let addressArr = []

    countrtyStates.map((ele) => {
      if (ele.value === states) {
        nameOfstate = ele.option
      }
    })
    let nameOfDistrict = ""
    District.map((ele) => {
      if (ele.value === district) {
        nameOfDistrict = ele.option
      }
    })
    if (formValidation(formData)) {
      setDeliveryAddressDetails((prev) => ({
        ...prev,
        deliveryAddress: deliveryAddress,
        country: country,
        district: district,
        states: states,
        pincode: pincode,
        stateCD: nameOfstate,
        districtCD: nameOfDistrict

      }))
      let obj = {
        deliveryAddress: deliveryAddress,
        country: country,
        district: district,
        states: states,
        pincode: pincode,
        stateCD: nameOfstate,
        districtCD: nameOfDistrict
      }
      addressArr.push(obj)
      setSaveAddressDetailsBackUp(addressArr)
      setBackdropOpen(false);
      setOpen(false);
    } else {
      setBackdropOpen(false);
    }

  }
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      consigneeName:data.consigneeName!==""?data.consigneeName:data.partyName.label,
      gstin:data.consigneeGST!==""?data.consigneeGST:data.gstin

    }))
  }, [data, open])

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      // disableBackdropClick
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}

    >
      <Fade in={open}>
        <Box sx={style}>
          <Box
            sx={{
              backgroundColor: "primary.main",
              padding: "5px 15px",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: "#fff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                Edit Delivery Address
                <IconButton aria-label="delete" onClick={handleClose}>
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              backgroundColor: "white",
              padding: "15px",
              height: { xs: "400px", sm: "auto" },
              overflowY: { xs: "scroll", sm: "hidden" },
              minWidth: { xs: "400px" },
            }}
          >
            {/* <Box
              sx={{
                display: "flex",
                alignItems: { sm: "center" },
                flexWrap: { xs: "wrap", md: "nowrap" },
                flexDirection: { xs: "column", sm: "row" },
                marginBottom: "0px",
              }}
            > */}
            <Box sx={{
              display: "flex", flexDirection: { xs: "column", sm: "column" },
              flexWrap: { xs: "wrap", md: "nowrap" }
            }}>
              {gstStatus !== 1 ?
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: "flex" }}>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      error={state.errorStatus.consigneeName == true ? true : false}
                      name="consigneeName"
                      placeholder="Consignee Name"
                      label="Consignee Name"
                      size="small"
                      value={state.consigneeName}
                      sx={{
                        ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                          fontSize: "14px",
                        },
                        label: {
                          fontSize: "14px",
                        },
                      }}
                      onChange={(e) => {
                        const name = e.target.name;
                        const value = e.target.value;
                        if (value === "") {
                          setState((prev) => ({
                            ...prev,
                            ["consigneeName"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["consigneeName"]: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["consigneeName"]: "Consignee Name is required",
                            },
                          }));
                        } else {
                          setData((prev)=>({
                            ...prev,
                            consigneeName:value
                          }))

                          setState((prev) => ({
                            ...prev,
                            ["consigneeName"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["consigneeName"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["consigneeName"]: "",
                            },
                          }));

                        }
                      }}
                    />
                     <Typography
                      sx={{
                        marginTop: "2px",
                        marginLeft: "10px",
                        marginBottom: "0px",
                        fontSize: "11px",
                        color: "danger.main",
                      }}
                    >
                      {state.errorFields.consigneeName}
                    </Typography>
                  </Box>
                  <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                    <TextField
                      error={state.errorStatus.gstin == true ? true : false}
                      name="gstin"
                      placeholder="GSTIN"
                      label="GSTIN"
                      size="small"
                      value={state.gstin}
                      disabled={partyDetails.GSTCategory=="UB"?true:false}
                      onChange={(e) => {
                        const name = e.target.name;
                        const value = e.target.value;
                        setData((prev)=>({
                          ...prev,
                          consigneeGST:value
                        }))
                        // if (value === "") {
                        //   setState((prev) => ({
                        //     ...prev,
                        //     ["gstin"]: value,
                        //     ["errorStatus"]: {
                        //       ...prev.errorStatus,
                        //       ["gstin"]: true,
                        //     },
                        //     ["errorFields"]: {
                        //       ...prev.errorFields,
                        //       ["gstin"]: "GSTIN is required",
                        //     },
                        //   }));
                        // } else {
                          if (!(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Za-z]{1}$/.test(
                            value
                          ))) {
                            setState((prev) => ({
                              ...prev,
                              ["gstin"]: value,
                              ["errorStatus"]: {
                                ...prev.errorStatus,
                                ["gstin"]: true,
                              },
                              ["errorFields"]: {
                                ...prev.errorFields,
                                ["gstin"]: "Invalid GSTIN",
                              },
                            }));
                          } else {
                            setState((prev) => ({
                              ...prev,
                              ["gstin"]: value,
                              ["errorStatus"]: {
                                ...prev.errorStatus,
                                ["gstin"]: false,
                              },
                              ["errorFields"]: {
                                ...prev.errorFields,
                                ["gstin"]: "",
                              },
                            }));
                          }
                        // }
                      }}
                      sx={{
                        ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                          fontSize: "14px",
                        },
                        label: {
                          fontSize: "14px",
                        },
                      }}

                    />
                    <Typography
                      sx={{
                        marginTop: "2px",
                        marginLeft: "10px",
                        marginBottom: "0px",
                        fontSize: "11px",
                        color: "danger.main",
                      }}
                    >
                      {state.errorFields.gstin}
                    </Typography>
                  </Box>
                </Box> : <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.consigneeName == true ? true : false}
                    name="consigneeName"
                    placeholder="Consignee Name"
                    label="Consignee Name"
                    size="small"
                    fullWidth
                    value={state.consigneeName}
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                    }}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["consigneeName"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["consigneeName"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["consigneeName"]: "Consignee Name is required",
                          },
                        }));
                      } else {
                        setData((prev)=>({
                          ...prev,
                          consigneeName:value
                        }))
                        setState((prev) => ({
                          ...prev,
                          ["consigneeName"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["consigneeName"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["consigneeName"]: "",
                          },
                        }));

                      }
                    }}
                  />
                   <Typography
                      sx={{
                        marginTop: "2px",
                        marginLeft: "10px",
                        marginBottom: "0px",
                        fontSize: "11px",
                        color: "danger.main",
                      }}
                    >
                      {state.errorFields.consigneeName}
                    </Typography>
                </Box>}
              <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                <TextField
                  error={state.errorStatus.deliveryAddress == true ? true : false}
                  name="deliveryaddress"
                  label="Delivery Address"
                  multiline
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="text"
                  value={state.deliveryAddress.replace(
                    /[**  ,]+/g,
                    ","
                  )}
                  required={true}
                  rows={4}
                  sx={{
                    ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                      fontSize: "14px",
                    },
                    label: {
                      fontSize: "14px",
                    },
                  }}
                  onChange={(e) => {
                    const name = e.target.name;
                    const value = e.target.value;
                    if (value === "") {
                      setState((prev) => ({
                        ...prev,
                        ["deliveryAddress"]: value,
                        ["errorStatus"]: {
                          ...prev.errorStatus,
                          ["deliveryAddress"]: true,
                        },
                        ["errorFields"]: {
                          ...prev.errorFields,
                          ["deliveryAddress"]: "Delivery Address is required",
                        },
                      }));
                    } else {
                      console.log("value", value);
                      setState((prev) => ({
                        ...prev,
                        ["deliveryAddress"]: value,
                        ["errorStatus"]: {
                          ...prev.errorStatus,
                          ["deliveryAddress"]: false,
                        },
                        ["errorFields"]: {
                          ...prev.errorFields,
                          ["deliveryAddress"]: "",
                        },
                      }));
                    }
                  }}
                />
                <Typography
                  sx={{
                    marginTop: "2px",
                    marginLeft: "10px",
                    marginBottom: "0px",
                    fontSize: "11px",
                    color: "danger.main",
                  }}
                >
                  {state.errorFields.deliveryAddress}
                </Typography>
              </Box>
              <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: "flex" }}>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <SelectField
                    name="district"
                    placeholder="District"
                    size="small"
                    value={state.district}
                    required={true}
                    state={state}
                    options={District}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["district"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["district"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["district"]: "District is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["district"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["district"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["district"]: "",
                          },
                        }));
                      }
                    }}
                  />
                </Box>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <SelectField
                    name="states"
                    placeholder="State/Province"
                    size="small"
                    state={state}
                    required={true}
                    value={state.states}
                    options={countrtyStates}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;

                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["states"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["states"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["states"]: "State/Province is required",
                          },
                        }));
                      } else {
                        getDistricts(value)
                        setState((prev) => ({
                          ...prev,
                          ["states"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["states"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["states"]: "",
                          },
                        }));
                      }
                    }}
                  />
                </Box>
              </Box>
              <Box sx={{ flex: { xs: 1, md: 1 }, m: 1, display: "flex" }}>
                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <SelectField
                    name="country"
                    placeholder="Country"
                    size="small"
                    fullWidth
                    state={state}
                    required={true}
                    value={state.country}
                    options={
                      countries}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      getStates(e.target.value);
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["country"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["country"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["country"]: "Country is required",
                          },
                        }));
                      } else {
                        setState((prev) => ({
                          ...prev,
                          ["country"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["country"]: false,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["country"]: "",
                          },
                        }));
                      }
                    }}
                  />
                </Box>


                <Box sx={{ flex: { xs: 1, md: 1 }, m: 1 }}>
                  <TextField
                    error={state.errorStatus.pincode == true ? true : false}
                    name="pincode"
                    label="Postal / Zip Code"
                    variant="outlined"
                    size="small"
                    fullWidth
                    type="text"
                    value={state.pincode}
                    required={true}
                    rows={4}
                    sx={{
                      ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                        fontSize: "14px",
                      },
                      label: {
                        fontSize: "14px",
                      },
                    }}
                    onChange={(e) => {
                      const name = e.target.name;
                      const value = e.target.value;
                      if (value === "") {
                        setState((prev) => ({
                          ...prev,
                          ["pincode"]: value,
                          ["errorStatus"]: {
                            ...prev.errorStatus,
                            ["pincode"]: true,
                          },
                          ["errorFields"]: {
                            ...prev.errorFields,
                            ["pincode"]: "Postal / Zip Code is required",
                          },
                        }));
                      } else {
                        if (!new RegExp(/^\d{6}$/).test(value)) {
                          setState((prev) => ({
                            ...prev,
                            ["pincode"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["pincode"]: true,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["pincode"]: "Invalid Postal / Zip Code",
                            },
                          }));
                        } else {
                          setState((prev) => ({
                            ...prev,
                            ["pincode"]: value,
                            ["errorStatus"]: {
                              ...prev.errorStatus,
                              ["pincode"]: false,
                            },
                            ["errorFields"]: {
                              ...prev.errorFields,
                              ["pincode"]: "",
                            },
                          }));
                        }
                      }
                    }}
                  />
                  <Typography
                    sx={{
                      marginTop: "2px",
                      marginLeft: "10px",
                      marginBottom: "0px",
                      fontSize: "11px",
                      color: "danger.main",
                    }}
                  >
                    {state.errorFields.pincode}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: { sm: "center" },
                flexWrap: { xs: "wrap", md: "nowrap" },
                flexDirection: { xs: "column", sm: "row" },
                marginBottom: "0px",
              }}
            >
            </Box>
          </Box>

          <Box
            sx={{
              // padding : "15px",
              // width:'100%',
              display: "flex",
              justifyContent: "space-between",
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Cancel
            </Button>
            <Button
              onClick={saveChanges}
              variant="contained"
              sx={{ flex: 1, margin: "10px", fontSize: "12px" }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default EditCreditDeliveryAddress;
